import test from './test.vue'
export default {
    install(Vue,options) {
        Vue.component('hellow',test)
    }
}


// WEBPACK FOOTER //
// ./src/lib/test.js